import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { I18nModule } from '@spartacus/core';
import { SortingComponent } from './sorting.component';

@NgModule({
  imports: [CommonModule, NgSelectModule, NgbDropdownModule, MatIconModule, FormsModule, I18nModule, SortingComponent],
  exports: [SortingComponent],
})
export class SortingModule {}
